import React from 'react';

const PatientAdminForm = ({ mode, setmode, formdata, setformdata, handlesubmit }) => {
  if (mode !== "editpatient") return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{formdata._id ? "Edit Patient" : "New Patient"}</h3>
          <button className="close-btn" onClick={() => setmode("")}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Name</label>
            <input
              type="text"
              className="form-input"
              value={formdata.name}
              onChange={(e) => setformdata({ ...formdata, name: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="text"
              className="form-input"
              value={formdata.phonenumber}
              onChange={(e) => setformdata({ ...formdata, phonenumber: e.target.value })}
            />
          </div>
          <div style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
            <button 
              className="btn-blue" 
              style={{ flex: 1 }} 
              onClick={handlesubmit}
            >
              Save Patient
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientAdminForm;